import { legacy_createStore as createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { thunk } from 'redux-thunk'
import { usersReducer } from './reducers/auth/usersReducer'
import { animalsReducer } from './reducers/other/animalsReducer'
import { protocolsReducer } from './reducers/other/protocolsReducer'
import { farmsReducer } from './reducers/other/farmsReducer'
import { lotsReducer } from './reducers/other/lotsReducer'
import { templatesReducer } from './reducers/other/templatesReducer'
import { zonesReducer } from './reducers/other/zonesReducer'
import { notificationsReducer } from './reducers/other/notificationsReducer'
import { eventsReducer } from './reducers/other/eventsReducer'

const intialState = {}
const appReducer = combineReducers({
    users: usersReducer,
    animals: animalsReducer,
    protocols: protocolsReducer,
    farms: farmsReducer,
    lots: lotsReducer,
    templates: templatesReducer,
    zones: zonesReducer,
    notifications: notificationsReducer,
    events: eventsReducer
})

const reducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducer, intialState, composeEnhancer(applyMiddleware(thunk)))

export default store